import { Card } from './Card';
import { Image } from './Image';
import { Typography } from './Typography';

interface Stat {
  title?: string;
  description?: string;
  icon?: Image;
}

interface StatsProps {
  data?: Stat[];
}

export const Stats: React.FC<StatsProps> = ({ data }) => (
  <div className="flex flex-wrap gap-8">
    {data?.map((item, index) => (
      <Card key={index} className="h-[6.5rem] min-w-[16rem] gap-6 p-6" elevated>
        <div className="flex h-12 w-12 items-center justify-center rounded-md border border-success-500 bg-success-50 p-3">
          <Image src={item?.icon} className="h-6 w-6 text-success-500" />
        </div>

        <div className="flex flex-col">
          <Typography variant="h4" className="whitespace-nowrap">
            {item?.title}
          </Typography>
          <Typography variant="subtitle3" className="whitespace-nowrap">
            {item?.description}
          </Typography>
        </div>
      </Card>
    ))}
  </div>
);
